export default "__VITE_ASSET__DB7ddRYC__"